/** 'vor 3 Std.' — how every timestamp on the dashboard is rendered. */
export function relativeTime(iso: string): string {
  const diffMs = new Date(iso).getTime() - Date.now();
  const units: [Intl.RelativeTimeFormatUnit, number][] = [
    ['day', 86_400_000],
    ['hour', 3_600_000],
    ['minute', 60_000],
  ];
  const format = new Intl.RelativeTimeFormat('de', { numeric: 'auto' });
  for (const [unit, ms] of units) {
    if (Math.abs(diffMs) >= ms) {
      return format.format(Math.round(diffMs / ms), unit);
    }
  }
  return format.format(0, 'minute');
}

/** '09.08.2026, 14:30' — the exact time, shown on hover. */
export function absoluteTime(iso: string): string {
  return new Date(iso).toLocaleString('de-DE', {
    dateStyle: 'short',
    timeStyle: 'short',
  });
}
